module.exports = __webpack_public_path__ + "img/20191206165243981.058ad09f.jpg";